import React, { memo } from 'react';
import { SubjectMessage } from '@surveycake/logic-engine';
import {
  useSubjectMessage,
  useSubjectId,
  UseSubjectMessageSelector
} from '@surveycake/react-logic-engine';
import { Typography } from '@surveycake/rc';
import { Tag } from '@surveycake/rc';
import { useSurveyConfig } from 'app/core/survey-config';
import { MessageType, createMessageResolver } from 'app/modules/subject';
import * as styles from './styles';

function createMessge<T extends MessageType>(type: T) {
  const resolver = createMessageResolver(type);
  const messageSelector: UseSubjectMessageSelector<
    SubjectMessage[T]
  > = message => message[type];

  function Message() {
    const id = useSubjectId();
    const messgae = useSubjectMessage(id, messageSelector);
    const { wording } = useSurveyConfig();
    const resolvedMessage = resolver(wording, messgae);

    if (!resolvedMessage) {
      return null;
    }

    if (type === 'info') {
      return (
        <Typography className={styles.info} variant="span" color="warning">
          {resolvedMessage}
        </Typography>
      );
    }

    return <Tag color="error">{resolvedMessage}</Tag>;
  }

  return memo(Message);
}

export const ErrorMessage = createMessge('error');
export const InfoMessage = createMessge('info');
